module.exports = __webpack_public_path__ + "static/media/ruby.ab4f7ad7.svg";